import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { ETypeOfNotification, setNotification } from 'medere-ui-framework';

/** Duraciones de la card flotante (design system §3.8.2): hay que llegar a leerla y entenderla. */
const SUCCESS_DURATION_MS = 5000;
const ERROR_DURATION_MS = 8000;

/**
 * Card flotante del design system (§3.8.2): una sola línea, solo informa.
 * Éxito: "{Entidad} {participio}". Error: "No se pudo {acción}. Intentá de nuevo." o el mensaje del backend.
 */
export default function useNotify() {
    const dispatch = useDispatch();

    const success = useCallback((title: string) => {
        dispatch(setNotification({
            title,
            icon: 'pi-check-circle',
            typeOfNotification: ETypeOfNotification.INFO,
            duration: SUCCESS_DURATION_MS,
        }));
    }, [dispatch]);

    const error = useCallback((title: string) => {
        dispatch(setNotification({
            title,
            icon: 'pi-times',
            typeOfNotification: ETypeOfNotification.ERROR,
            duration: ERROR_DURATION_MS,
        }));
    }, [dispatch]);

    return useMemo(() => ({ success, error }), [success, error]);
}
